"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultActiveSpeakerDetector_1 = require("../activespeakerdetector/DefaultActiveSpeakerDetector");

var DefaultAudioMixController_1 = require("../audiomixcontroller/DefaultAudioMixController");

var AudioProfile_1 = require("../audioprofile/AudioProfile");

var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");

var ConnectionHealthData_1 = require("../connectionhealthpolicy/ConnectionHealthData");

var SignalingAndMetricsConnectionMonitor_1 = require("../connectionmonitor/SignalingAndMetricsConnectionMonitor");

var DefaultEventController_1 = require("../eventcontroller/DefaultEventController");

var MeetingSessionStatus_1 = require("../meetingsession/MeetingSessionStatus");

var MeetingSessionStatusCode_1 = require("../meetingsession/MeetingSessionStatusCode");

var MeetingSessionVideoAvailability_1 = require("../meetingsession/MeetingSessionVideoAvailability");

var DefaultPingPong_1 = require("../pingpong/DefaultPingPong");

var DefaultRealtimeController_1 = require("../realtimecontroller/DefaultRealtimeController");

var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");

var DefaultSessionStateController_1 = require("../sessionstatecontroller/DefaultSessionStateController");

var SessionStateControllerAction_1 = require("../sessionstatecontroller/SessionStateControllerAction");

var SessionStateControllerState_1 = require("../sessionstatecontroller/SessionStateControllerState");

var SessionStateControllerTransitionResult_1 = require("../sessionstatecontroller/SessionStateControllerTransitionResult");

var DefaultSignalingClient_1 = require("../signalingclient/DefaultSignalingClient");

var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");

var SignalingClientVideoSubscriptionConfiguration_1 = require("../signalingclient/SignalingClientVideoSubscriptionConfiguration");

var SignalingProtocol_js_1 = require("../signalingprotocol/SignalingProtocol.js");

var DefaultStatsCollector_1 = require("../statscollector/DefaultStatsCollector");

var AttachMediaInputTask_1 = require("../task/AttachMediaInputTask");

var CleanRestartedSessionTask_1 = require("../task/CleanRestartedSessionTask");

var CleanStoppedSessionTask_1 = require("../task/CleanStoppedSessionTask");

var CreatePeerConnectionTask_1 = require("../task/CreatePeerConnectionTask");

var CreateSDPTask_1 = require("../task/CreateSDPTask");

var FinishGatheringICECandidatesTask_1 = require("../task/FinishGatheringICECandidatesTask");

var JoinAndReceiveIndexTask_1 = require("../task/JoinAndReceiveIndexTask");

var LeaveAndReceiveLeaveAckTask_1 = require("../task/LeaveAndReceiveLeaveAckTask");

var ListenForVolumeIndicatorsTask_1 = require("../task/ListenForVolumeIndicatorsTask");

var MonitorTask_1 = require("../task/MonitorTask");

var OpenSignalingConnectionTask_1 = require("../task/OpenSignalingConnectionTask");

var ParallelGroupTask_1 = require("../task/ParallelGroupTask");

var ReceiveAudioInputTask_1 = require("../task/ReceiveAudioInputTask");

var ReceiveTURNCredentialsTask_1 = require("../task/ReceiveTURNCredentialsTask");

var ReceiveVideoInputTask_1 = require("../task/ReceiveVideoInputTask");

var ReceiveVideoStreamIndexTask_1 = require("../task/ReceiveVideoStreamIndexTask");

var ReleaseMediaStreamsTask_1 = require("../task/ReleaseMediaStreamsTask");

var SendAndReceiveDataMessagesTask_1 = require("../task/SendAndReceiveDataMessagesTask");

var SerialGroupTask_1 = require("../task/SerialGroupTask");

var SetLocalDescriptionTask_1 = require("../task/SetLocalDescriptionTask");

var SetRemoteDescriptionTask_1 = require("../task/SetRemoteDescriptionTask");

var SubscribeAndReceiveSubscribeAckTask_1 = require("../task/SubscribeAndReceiveSubscribeAckTask");

var TimeoutTask_1 = require("../task/TimeoutTask");

var WaitForAttendeePresenceTask_1 = require("../task/WaitForAttendeePresenceTask");

var DefaultTransceiverController_1 = require("../transceivercontroller/DefaultTransceiverController");

var SimulcastTransceiverController_1 = require("../transceivercontroller/SimulcastTransceiverController");

var VideoOnlyTransceiverController_1 = require("../transceivercontroller/VideoOnlyTransceiverController");

var Types_1 = require("../utils/Types");

var DefaultVideoCaptureAndEncodeParameter_1 = require("../videocaptureandencodeparameter/DefaultVideoCaptureAndEncodeParameter");

var AllHighestVideoBandwidthPolicy_1 = require("../videodownlinkbandwidthpolicy/AllHighestVideoBandwidthPolicy");

var VideoAdaptiveProbePolicy_1 = require("../videodownlinkbandwidthpolicy/VideoAdaptiveProbePolicy");

var DefaultVideoStreamIdSet_1 = require("../videostreamidset/DefaultVideoStreamIdSet");

var DefaultVideoStreamIndex_1 = require("../videostreamindex/DefaultVideoStreamIndex");

var SimulcastVideoStreamIndex_1 = require("../videostreamindex/SimulcastVideoStreamIndex");

var DefaultVideoTileController_1 = require("../videotilecontroller/DefaultVideoTileController");

var DefaultVideoTileFactory_1 = require("../videotilefactory/DefaultVideoTileFactory");

var DefaultSimulcastUplinkPolicy_1 = require("../videouplinkbandwidthpolicy/DefaultSimulcastUplinkPolicy");

var NScaleVideoUplinkBandwidthPolicy_1 = require("../videouplinkbandwidthpolicy/NScaleVideoUplinkBandwidthPolicy");

var DefaultVolumeIndicatorAdapter_1 = require("../volumeindicatoradapter/DefaultVolumeIndicatorAdapter");

var AudioVideoControllerState_1 = require("./AudioVideoControllerState");

var DefaultAudioVideoController = /*#__PURE__*/function () {
  function DefaultAudioVideoController(configuration, logger, webSocketAdapter, mediaStreamBroker, reconnectController, eventReporter) {
    _classCallCheck(this, DefaultAudioVideoController);

    this._audioProfile = new AudioProfile_1.default();
    this.connectionHealthData = new ConnectionHealthData_1.default();
    this.observerQueue = new Set();
    this.meetingSessionContext = new AudioVideoControllerState_1.default();
    this.enableSimulcast = false;
    this.useUpdateTransceiverControllerForUplink = false;
    this.totalRetryCount = 0;
    this.startAudioVideoTimestamp = 0;
    this.mayNeedRenegotiationForSimulcastLayerChange = false;
    this.receiveIndexTask = undefined;
    this.monitorTask = undefined;
    this.destroyed = false;
    /** @internal */

    this.usePromises = true;
    this._logger = logger;
    this.sessionStateController = new DefaultSessionStateController_1.default(this._logger);
    this._configuration = configuration;
    this.enableSimulcast = configuration.enableSimulcastForUnifiedPlanChromiumBasedBrowsers && new DefaultBrowserBehavior_1.default().hasChromiumWebRTC();
    this._webSocketAdapter = webSocketAdapter;
    this._realtimeController = new DefaultRealtimeController_1.default();

    this._realtimeController.realtimeSetLocalAttendeeId(configuration.credentials.attendeeId, configuration.credentials.externalUserId);

    this._mediaStreamBroker = mediaStreamBroker;
    this._reconnectController = reconnectController;
    this._videoTileController = new DefaultVideoTileController_1.default(new DefaultVideoTileFactory_1.default(), this, this._logger);
    this._audioMixController = new DefaultAudioMixController_1.default(this._logger);
    this.meetingSessionContext.logger = this._logger;
    this._eventController = new DefaultEventController_1.default(this, eventReporter);
  }

  _createClass(DefaultAudioVideoController, [{
    key: "destroy",
    value: function destroy() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.observerQueue.clear();
                this.destroyed = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "configuration",
    get: function get() {
      return this._configuration;
    }
  }, {
    key: "realtimeController",
    get: function get() {
      return this._realtimeController;
    }
  }, {
    key: "activeSpeakerDetector",
    get: function get() {
      // Lazy init.
      if (!this._activeSpeakerDetector) {
        this._activeSpeakerDetector = new DefaultActiveSpeakerDetector_1.default(this._realtimeController, this._configuration.credentials.attendeeId, this.handleHasBandwidthPriority.bind(this));
      }

      return this._activeSpeakerDetector;
    }
  }, {
    key: "videoTileController",
    get: function get() {
      return this._videoTileController;
    }
  }, {
    key: "audioMixController",
    get: function get() {
      return this._audioMixController;
    }
  }, {
    key: "eventController",
    get: function get() {
      return this._eventController;
    }
  }, {
    key: "logger",
    get: function get() {
      return this._logger;
    }
  }, {
    key: "rtcPeerConnection",
    get: function get() {
      return this.meetingSessionContext && this.meetingSessionContext.peer || null;
    }
  }, {
    key: "mediaStreamBroker",
    get: function get() {
      return this._mediaStreamBroker;
    }
  }, {
    key: "getRTCPeerConnectionStats",
    value: function getRTCPeerConnectionStats(selector) {
      if (!this.rtcPeerConnection) {
        return null;
      }

      return this.rtcPeerConnection.getStats(selector);
    }
  }, {
    key: "setAudioProfile",
    value: function setAudioProfile(audioProfile) {
      this._audioProfile = audioProfile;
    }
  }, {
    key: "addObserver",
    value: function addObserver(observer) {
      this.logger.info('adding meeting observer');
      this.observerQueue.add(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.logger.info('removing meeting observer');
      this.observerQueue.delete(observer);
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(observerFunc) {
      var _this = this;

      var _iterator = _createForOfIteratorHelper(this.observerQueue),
          _step;

      try {
        var _loop = function _loop() {
          var observer = _step.value;
          AsyncScheduler_1.default.nextTick(function () {
            if (_this.observerQueue.has(observer)) {
              observerFunc(observer);
            }
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "initSignalingClient",
    value: function initSignalingClient() {
      if (this.meetingSessionContext.signalingClient) {
        return;
      }

      this.connectionHealthData.reset();
      this.meetingSessionContext = new AudioVideoControllerState_1.default();
      this.meetingSessionContext.logger = this.logger;
      this.meetingSessionContext.eventController = this.eventController;
      this.meetingSessionContext.browserBehavior = new DefaultBrowserBehavior_1.default();
      this.meetingSessionContext.meetingSessionConfiguration = this.configuration;
      this.meetingSessionContext.signalingClient = new DefaultSignalingClient_1.default(this._webSocketAdapter, this.logger);
    }
  }, {
    key: "uninstallPreStartObserver",
    value: function uninstallPreStartObserver() {
      this.meetingSessionContext.signalingClient.removeObserver(this.preStartObserver);
      this.preStartObserver = undefined;
    }
  }, {
    key: "prestart",
    value: function prestart() {
      var _this2 = this;

      this.logger.info('Pre-connecting signaling connection.');
      return this.createOrReuseSignalingTask().run().then(function () {
        var handleClosed = function handleClosed() {
          return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
            return _regenerator.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    this.logger.info('Early connection closed; discarding signaling task.');
                    this.signalingTask = undefined;
                    this.uninstallPreStartObserver();

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));
        };

        _this2.preStartObserver = {
          handleSignalingClientEvent: function handleSignalingClientEvent(event) {
            if (event.type === SignalingClientEventType_1.default.WebSocketClosed) {
              handleClosed();
            }
          }
        };

        _this2.meetingSessionContext.signalingClient.registerObserver(_this2.preStartObserver);
      }).catch(function (e) {
        _this2.logger.error("Signaling task pre-start failed: ".concat(e)); // Clean up just in case a subsequent attempt will succeed.


        _this2.signalingTask = undefined;
      });
    }
  }, {
    key: "start",
    value: function start(options) {
      var _this3 = this;

      this.startReturningPromise(options).then(function () {
        _this3.logger.info('start completed');
      }) // Just-in-case error handling.
      .catch(
      /* istanbul ignore next */
      function (e) {
        _this3.logger.error("start failed: ".concat(e));
      });
    } // This is public (albeit marked internal) for tests only.

    /* @internal */

  }, {
    key: "startReturningPromise",
    value: function startReturningPromise(options) {
      var _this4 = this;

      if ((options === null || options === void 0 ? void 0 : options.signalingOnly) === true) {
        return this.prestart();
      } // For side-effects: lazy getter.


      this.activeSpeakerDetector;
      return new Promise(function (resolve, reject) {
        _this4.sessionStateController.perform(SessionStateControllerAction_1.default.Connect, function () {
          _this4.actionConnect(false).then(resolve).catch(reject);
        });
      });
    } // @ts-ignore

  }, {
    key: "connectWithPromises",
    value: function connectWithPromises(needsToWaitForAttendeePresence) {
      var _this5 = this;

      var context = this.meetingSessionContext; // Syntactic sugar.

      var timeout = function timeout(timeoutMs, task) {
        return new TimeoutTask_1.default(_this5.logger, task, timeoutMs);
      }; // First layer.


      this.monitorTask = new MonitorTask_1.default(context, this.configuration.connectionHealthPolicyConfiguration, this.connectionHealthData);
      var monitor = this.monitorTask.once(); // Second layer.

      var receiveAudioInput = new ReceiveAudioInputTask_1.default(context).once();
      this.receiveIndexTask = new ReceiveVideoStreamIndexTask_1.default(context);
      var signaling = new SerialGroupTask_1.default(this.logger, 'Signaling', [// If pre-connecting, this will be an existing task that has already been run.
      this.createOrReuseSignalingTask(), new ListenForVolumeIndicatorsTask_1.default(context), new SendAndReceiveDataMessagesTask_1.default(context), new JoinAndReceiveIndexTask_1.default(context), new ReceiveTURNCredentialsTask_1.default(context), this.receiveIndexTask]).once(); // Third layer.

      var createPeerConnection = new CreatePeerConnectionTask_1.default(context).once(signaling);
      var attachMediaInput = new AttachMediaInputTask_1.default(context).once(createPeerConnection, receiveAudioInput); // Mostly serial section -- kept as promises to allow for finer-grained breakdown.

      var createSDP = new CreateSDPTask_1.default(context).once(attachMediaInput);
      var setLocalDescription = new SetLocalDescriptionTask_1.default(context).once(createSDP);
      var ice = new FinishGatheringICECandidatesTask_1.default(context).once(setLocalDescription);
      var subscribeAck = new SubscribeAndReceiveSubscribeAckTask_1.default(context).once(ice); // The ending is a delicate time: we need the connection as a whole to have a timeout,
      // and for the attendee presence timer to not start ticking until after the subscribe/ack.

      return new SerialGroupTask_1.default(this.logger, this.wrapTaskName('AudioVideoStart'), [monitor, timeout(this.configuration.connectionTimeoutMs, new SerialGroupTask_1.default(this.logger, 'Peer', [// The order of these two matters. If canceled, the first one that's still running
      // will contribute any special rejection, and we don't want that to be "attendee not found"!
      subscribeAck, needsToWaitForAttendeePresence ? new TimeoutTask_1.default(this.logger, new ParallelGroupTask_1.default(this.logger, 'FinalizeConnection', [new WaitForAttendeePresenceTask_1.default(context), new SetRemoteDescriptionTask_1.default(context)]), this.meetingSessionContext.meetingSessionConfiguration.attendeePresenceTimeoutMs) :
      /* istanbul ignore next */
      new SetRemoteDescriptionTask_1.default(context)]))]);
    }
  }, {
    key: "connectWithTasks",
    value: function connectWithTasks(needsToWaitForAttendeePresence) {
      this.receiveIndexTask = new ReceiveVideoStreamIndexTask_1.default(this.meetingSessionContext);
      this.monitorTask = new MonitorTask_1.default(this.meetingSessionContext, this.configuration.connectionHealthPolicyConfiguration, this.connectionHealthData);
      return new SerialGroupTask_1.default(this.logger, this.wrapTaskName('AudioVideoStart'), [this.monitorTask, new ReceiveAudioInputTask_1.default(this.meetingSessionContext), new TimeoutTask_1.default(this.logger, new SerialGroupTask_1.default(this.logger, 'Media', [new SerialGroupTask_1.default(this.logger, 'Signaling', [new OpenSignalingConnectionTask_1.default(this.meetingSessionContext), new ListenForVolumeIndicatorsTask_1.default(this.meetingSessionContext), new SendAndReceiveDataMessagesTask_1.default(this.meetingSessionContext), new JoinAndReceiveIndexTask_1.default(this.meetingSessionContext), new ReceiveTURNCredentialsTask_1.default(this.meetingSessionContext), this.receiveIndexTask]), new SerialGroupTask_1.default(this.logger, 'Peer', [new CreatePeerConnectionTask_1.default(this.meetingSessionContext), new AttachMediaInputTask_1.default(this.meetingSessionContext), new CreateSDPTask_1.default(this.meetingSessionContext), new SetLocalDescriptionTask_1.default(this.meetingSessionContext), new FinishGatheringICECandidatesTask_1.default(this.meetingSessionContext), new SubscribeAndReceiveSubscribeAckTask_1.default(this.meetingSessionContext), needsToWaitForAttendeePresence ? new TimeoutTask_1.default(this.logger, new ParallelGroupTask_1.default(this.logger, 'FinalizeConnection', [new WaitForAttendeePresenceTask_1.default(this.meetingSessionContext), new SetRemoteDescriptionTask_1.default(this.meetingSessionContext)]), this.meetingSessionContext.meetingSessionConfiguration.attendeePresenceTimeoutMs) :
      /* istanbul ignore next */
      new SetRemoteDescriptionTask_1.default(this.meetingSessionContext)])]), this.configuration.connectionTimeoutMs)]);
    }
  }, {
    key: "actionConnect",
    value: function actionConnect(reconnecting) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var _this6 = this;

        var useAudioConnection, simulcastPolicy, needsToWaitForAttendeePresence, connect, status;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.initSignalingClient(); // We no longer need to watch for the early connection dropping; we're back where
                // we otherwise would have been had we not pre-started.

                this.uninstallPreStartObserver();
                this.meetingSessionContext.mediaStreamBroker = this._mediaStreamBroker;
                this.meetingSessionContext.realtimeController = this._realtimeController;
                this.meetingSessionContext.audioMixController = this._audioMixController;
                this.meetingSessionContext.audioVideoController = this;
                useAudioConnection = !!this.configuration.urls.audioHostURL;

                if (!useAudioConnection) {
                  this.logger.info("Using video only transceiver controller");
                  this.meetingSessionContext.transceiverController = new VideoOnlyTransceiverController_1.default(this.logger, this.meetingSessionContext.browserBehavior);
                } else if (this.enableSimulcast) {
                  this.logger.info("Using transceiver controller with simulcast support");
                  this.meetingSessionContext.transceiverController = new SimulcastTransceiverController_1.default(this.logger, this.meetingSessionContext.browserBehavior);
                } else {
                  this.logger.info("Using default transceiver controller");
                  this.meetingSessionContext.transceiverController = new DefaultTransceiverController_1.default(this.logger, this.meetingSessionContext.browserBehavior);
                }

                this.meetingSessionContext.volumeIndicatorAdapter = new DefaultVolumeIndicatorAdapter_1.default(this.logger, this._realtimeController, DefaultAudioVideoController.MIN_VOLUME_DECIBELS, DefaultAudioVideoController.MAX_VOLUME_DECIBELS, this.configuration.credentials.attendeeId);
                this.meetingSessionContext.videoTileController = this._videoTileController;
                this.meetingSessionContext.videoDownlinkBandwidthPolicy = this.configuration.videoDownlinkBandwidthPolicy;
                this.meetingSessionContext.videoUplinkBandwidthPolicy = this.configuration.videoUplinkBandwidthPolicy;
                this.meetingSessionContext.enableSimulcast = this.enableSimulcast;

                if (this.enableSimulcast) {
                  simulcastPolicy = this.meetingSessionContext.videoUplinkBandwidthPolicy;

                  if (!simulcastPolicy) {
                    simulcastPolicy = new DefaultSimulcastUplinkPolicy_1.default(this.configuration.credentials.attendeeId, this.meetingSessionContext.logger);
                    this.meetingSessionContext.videoUplinkBandwidthPolicy = simulcastPolicy;
                  }

                  simulcastPolicy.addObserver(this);

                  if (!this.meetingSessionContext.videoDownlinkBandwidthPolicy) {
                    this.meetingSessionContext.videoDownlinkBandwidthPolicy = new VideoAdaptiveProbePolicy_1.default(this.meetingSessionContext.logger);
                  }

                  this.meetingSessionContext.videoStreamIndex = new SimulcastVideoStreamIndex_1.default(this.logger);
                } else {
                  this.meetingSessionContext.enableSimulcast = false;
                  this.meetingSessionContext.videoStreamIndex = new DefaultVideoStreamIndex_1.default(this.logger);

                  if (!this.meetingSessionContext.videoUplinkBandwidthPolicy) {
                    this.meetingSessionContext.videoUplinkBandwidthPolicy = new NScaleVideoUplinkBandwidthPolicy_1.default(this.configuration.credentials.attendeeId, !this.meetingSessionContext.browserBehavior.disableResolutionScaleDown(), this.meetingSessionContext.logger);
                  }

                  if (!this.meetingSessionContext.videoDownlinkBandwidthPolicy) {
                    this.meetingSessionContext.videoDownlinkBandwidthPolicy = new AllHighestVideoBandwidthPolicy_1.default(this.configuration.credentials.attendeeId);
                  }

                  if (this.meetingSessionContext.videoUplinkBandwidthPolicy.setTransceiverController && this.meetingSessionContext.videoUplinkBandwidthPolicy.updateTransceiverController && this.meetingSessionContext.browserBehavior.requiresUnifiedPlan()) {
                    this.useUpdateTransceiverControllerForUplink = true;
                    this.meetingSessionContext.videoUplinkBandwidthPolicy.setTransceiverController(this.meetingSessionContext.transceiverController);
                  }

                  this.meetingSessionContext.audioProfile = this._audioProfile;
                }

                if (this.meetingSessionContext.videoDownlinkBandwidthPolicy.bindToTileController) {
                  this.meetingSessionContext.videoDownlinkBandwidthPolicy.bindToTileController(this._videoTileController);
                }

                this.meetingSessionContext.lastKnownVideoAvailability = new MeetingSessionVideoAvailability_1.default();
                this.meetingSessionContext.videoCaptureAndEncodeParameter = new DefaultVideoCaptureAndEncodeParameter_1.default(0, 0, 0, 0, false);
                this.meetingSessionContext.videosToReceive = new DefaultVideoStreamIdSet_1.default();
                this.meetingSessionContext.videosPaused = new DefaultVideoStreamIdSet_1.default();
                this.meetingSessionContext.statsCollector = new DefaultStatsCollector_1.default(this, this.logger, this.meetingSessionContext.browserBehavior);
                this.meetingSessionContext.connectionMonitor = new SignalingAndMetricsConnectionMonitor_1.default(this, this._realtimeController, this._videoTileController, this.connectionHealthData, new DefaultPingPong_1.default(this.meetingSessionContext.signalingClient, DefaultAudioVideoController.PING_PONG_INTERVAL_MS, this.logger), this.meetingSessionContext.statsCollector);
                this.meetingSessionContext.reconnectController = this._reconnectController;
                this.meetingSessionContext.videoDeviceInformation = {};

                if (!reconnecting) {
                  this.totalRetryCount = 0;

                  this._reconnectController.reset();

                  this.startAudioVideoTimestamp = Date.now();
                  this.forEachObserver(function (observer) {
                    Types_1.Maybe.of(observer.audioVideoDidStartConnecting).map(function (f) {
                      return f.bind(observer)(false);
                    });
                  });
                  /* istanbul ignore else */

                  if (this.eventController) {
                    this.eventController.publishEvent('meetingStartRequested');
                  }
                }

                this.meetingSessionContext.startAudioVideoTimestamp = this.startAudioVideoTimestamp;

                if (this._reconnectController.hasStartedConnectionAttempt()) {
                  // This does not reset the reconnect deadline, but declare it's not the first connection.
                  this._reconnectController.startedConnectionAttempt(false);
                } else {
                  this._reconnectController.startedConnectionAttempt(true);
                } // No attendee presence event will be triggered if there is no audio connection.
                // Waiting for attendee presence is explicitly executed
                // if `attendeePresenceTimeoutMs` is configured to larger than 0.


                needsToWaitForAttendeePresence = useAudioConnection && this.meetingSessionContext.meetingSessionConfiguration.attendeePresenceTimeoutMs > 0;
                this.logger.info('Needs to wait for attendee presence? ' + needsToWaitForAttendeePresence);

                if (this.usePromises) {
                  connect = this.connectWithPromises(needsToWaitForAttendeePresence);
                } else {
                  connect = this.connectWithTasks(needsToWaitForAttendeePresence);
                } // The rest.


                _context4.prev = 29;
                _context4.next = 32;
                return connect.run();

              case 32:
                this.connectionHealthData.setConnectionStartTime();
                this.sessionStateController.perform(SessionStateControllerAction_1.default.FinishConnecting, function () {
                  /* istanbul ignore else */
                  if (_this6.eventController) {
                    _this6.meetingSessionContext.meetingStartDurationMs = Date.now() - _this6.startAudioVideoTimestamp;

                    _this6.eventController.publishEvent('meetingStartSucceeded', {
                      maxVideoTileCount: _this6.meetingSessionContext.maxVideoTileCount,
                      poorConnectionCount: _this6.meetingSessionContext.poorConnectionCount,
                      retryCount: _this6.totalRetryCount,
                      signalingOpenDurationMs: _this6.meetingSessionContext.signalingOpenDurationMs,
                      iceGatheringDurationMs: _this6.meetingSessionContext.iceGatheringDurationMs,
                      meetingStartDurationMs: _this6.meetingSessionContext.meetingStartDurationMs
                    });
                  }

                  _this6.meetingSessionContext.startTimeMs = Date.now();

                  _this6.actionFinishConnecting();
                });
                _context4.next = 45;
                break;

              case 36:
                _context4.prev = 36;
                _context4.t0 = _context4["catch"](29);
                this.signalingTask = undefined;
                status = new MeetingSessionStatus_1.default(this.getMeetingStatusCode(_context4.t0) || MeetingSessionStatusCode_1.default.TaskFailed);
                this.logger.info("Start failed: ".concat(status, " due to error ").concat(_context4.t0, ".")); // I am not able to successfully reach this state in the test suite with mock
                // websockets -- it always ends up in 'Disconnecting' instead. As such, this
                // has to be marked for Istanbul.

                /* istanbul ignore if */

                if (!(this.sessionStateController.state() === SessionStateControllerState_1.default.NotConnected)) {
                  _context4.next = 44;
                  break;
                }

                // There's no point trying to 'disconnect', because we're not connected.
                // The session state controller will bail.
                this.logger.info('Start failed and not connected. Not cleaning up.');
                return _context4.abrupt("return");

              case 44:
                this.sessionStateController.perform(SessionStateControllerAction_1.default.Fail, function () {
                  return __awaiter(_this6, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
                    return _regenerator.default.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return this.actionDisconnect(status, true, _context4.t0);

                          case 2:
                            if (!this.handleMeetingSessionStatus(status, _context4.t0)) {
                              this.notifyStop(status, _context4.t0);
                            }

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, this);
                  }));
                });

              case 45:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[29, 36]]);
      }));
    }
  }, {
    key: "createOrReuseSignalingTask",
    value: function createOrReuseSignalingTask() {
      if (!this.signalingTask) {
        this.initSignalingClient();
        this.signalingTask = new TimeoutTask_1.default(this.logger, new OpenSignalingConnectionTask_1.default(this.meetingSessionContext), this.configuration.connectionTimeoutMs).once();
      }

      return this.signalingTask;
    }
  }, {
    key: "actionFinishConnecting",
    value: function actionFinishConnecting() {
      this.signalingTask = undefined;
      this.meetingSessionContext.videoDuplexMode = SignalingProtocol_js_1.SdkStreamServiceType.RX;

      if (!this.meetingSessionContext.enableSimulcast) {
        if (this.useUpdateTransceiverControllerForUplink) {
          this.meetingSessionContext.videoUplinkBandwidthPolicy.updateTransceiverController();
        } else {
          this.enforceBandwidthLimitationForSender(this.meetingSessionContext.videoCaptureAndEncodeParameter.encodeBitrates()[0]);
        }
      }

      this.forEachObserver(function (observer) {
        Types_1.Maybe.of(observer.audioVideoDidStart).map(function (f) {
          return f.bind(observer)();
        });
      });

      this._reconnectController.reset();
    }
    /* @internal */

  }, {
    key: "stopReturningPromise",
    value: function stopReturningPromise() {
      var _this7 = this;

      var _a; // In order to avoid breaking backward compatibility, when only the
      // signaling connection is established we appear to not be connected.
      // We handle this by simply disconnecting the websocket directly.


      if (this.sessionStateController.state() === SessionStateControllerState_1.default.NotConnected) {
        // Unfortunately, this does not return a promise.
        (_a = this.meetingSessionContext.signalingClient) === null || _a === void 0 ? void 0 : _a.closeConnection(); // Clean up any open streams.

        return new ReleaseMediaStreamsTask_1.default(this.meetingSessionContext).run();
      }
      /*
        Stops the current audio video meeting session.
        The stop method execution is deferred and executed after
        the current reconnection attempt completes.
        It disables any further reconnection attempts.
        Upon completion, AudioVideoObserver's `audioVideoDidStop`
        callback function is called with `MeetingSessionStatusCode.Left`.
      */


      return new Promise(function (resolve, reject) {
        _this7.sessionStateController.perform(SessionStateControllerAction_1.default.Disconnect, function () {
          _this7._reconnectController.disableReconnect();

          _this7.logger.info('attendee left meeting, session will not be reconnected');

          _this7.actionDisconnect(new MeetingSessionStatus_1.default(MeetingSessionStatusCode_1.default.Left), false, null).then(resolve).catch(reject);
        });
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      this.stopReturningPromise();
    }
  }, {
    key: "actionDisconnect",
    value: function actionDisconnect(status, reconnecting, error) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _this8 = this;

        var subtasks;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return new SerialGroupTask_1.default(this.logger, this.wrapTaskName('AudioVideoStop'), [new TimeoutTask_1.default(this.logger, new LeaveAndReceiveLeaveAckTask_1.default(this.meetingSessionContext), this.configuration.connectionTimeoutMs)]).run();

              case 3:
                _context5.next = 8;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5["catch"](0);
                this.logger.info('fail to stop');

              case 8:
                _context5.prev = 8;
                subtasks = [new TimeoutTask_1.default(this.logger, new CleanStoppedSessionTask_1.default(this.meetingSessionContext), this.configuration.connectionTimeoutMs)];

                if (!reconnecting) {
                  subtasks.push(new ReleaseMediaStreamsTask_1.default(this.meetingSessionContext));
                }

                _context5.next = 13;
                return new SerialGroupTask_1.default(this.logger, this.wrapTaskName('AudioVideoClean'), subtasks).run();

              case 13:
                _context5.next = 18;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t1 = _context5["catch"](8);

                /* istanbul ignore next */
                this.logger.info('fail to clean');

              case 18:
                this.sessionStateController.perform(SessionStateControllerAction_1.default.FinishDisconnecting, function () {
                  if (!reconnecting) {
                    _this8.notifyStop(status, error);
                  }
                });

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 5], [8, 15]]);
      }));
    }
  }, {
    key: "update",
    value: function update() {
      var _this9 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        needsRenegotiation: true
      };
      var needsRenegotiation = options.needsRenegotiation; // Check in case this function has been called before peer connection is set up
      // since that is necessary to try to update remote videos without the full resubscribe path

      needsRenegotiation || (needsRenegotiation = this.meetingSessionContext.peer === undefined); // If updating local or remote video without negotiation fails, fall back to renegotiation

      needsRenegotiation || (needsRenegotiation = !this.updateRemoteVideosFromLastVideosToReceive());
      needsRenegotiation || (needsRenegotiation = !this.updateLocalVideoFromPolicy()); // `MeetingSessionContext.lastVideosToReceive` needs to be updated regardless

      this.meetingSessionContext.lastVideosToReceive = this.meetingSessionContext.videosToReceive;

      if (!needsRenegotiation) {
        this.logger.info('Update request does not require resubscribe'); // Call `actionFinishUpdating` to apply the new encoding parameters that may have been set in `updateLocalVideoFromPolicy`.

        this.actionFinishUpdating();
        return true; // Skip the subscribe!
      }

      this.logger.info('Update request requires resubscribe');
      var result = this.sessionStateController.perform(SessionStateControllerAction_1.default.Update, function () {
        _this9.actionUpdateWithRenegotiation(true);
      });
      return result === SessionStateControllerTransitionResult_1.default.Transitioned || result === SessionStateControllerTransitionResult_1.default.DeferredTransition;
    } // This function will try to use the diff between `this.meetingSessionContext.lastVideosToReceive`
    // and `this.meetingSessionContext.videosToReceive` to determine if the changes can be accomplished
    // through `SignalingClient.remoteVideoUpdate` rather then the full subscribe.
    //
    // It requires the caller to manage `this.meetingSessionContext.lastVideosToReceive`
    // and `this.meetingSessionContext.videosToReceive` so that `this.meetingSessionContext.lastVideosToReceive`
    // contains the stream IDs from either last time a subscribe was set, or last time this function was set.
    //
    // It will return true if succesful, if false the caller must fall back to a full renegotiation

  }, {
    key: "updateRemoteVideosFromLastVideosToReceive",
    value: function updateRemoteVideosFromLastVideosToReceive() {
      var _a, _b;

      var context = this.meetingSessionContext;

      if (((_a = context.videosToReceive) === null || _a === void 0 ? void 0 : _a.empty()) || ((_b = context.lastVideosToReceive) === null || _b === void 0 ? void 0 : _b.empty())) {
        return false;
      } // Check existence of all required dependencies and requisite functions


      if (!context.transceiverController || !context.transceiverController.getMidForStreamId || !context.transceiverController.setStreamIdForMid || !context.videosToReceive.forEach || !context.signalingClient.remoteVideoUpdate || !context.videoStreamIndex.overrideStreamIdMappings) {
        return false;
      }

      var added = [];
      var simulcastStreamUpdates = new Map();
      var removed = [];

      if (context.lastVideosToReceive === null) {
        added = context.videosToReceive.array();
      } else {
        var index = context.videoStreamIndex;
        context.videosToReceive.forEach(function (currentId) {
          if (context.lastVideosToReceive.contain(currentId)) {
            return;
          } // Check if group ID exists in previous set (i.e. simulcast stream switch)


          var foundUpdatedPreviousStreamId = false;
          context.lastVideosToReceive.forEach(function (previousId) {
            if (foundUpdatedPreviousStreamId) {
              return; // Short circuit since we have already found it
            }

            if (index.StreamIdsInSameGroup(previousId, currentId)) {
              simulcastStreamUpdates.set(previousId, currentId);
              foundUpdatedPreviousStreamId = true;
            }
          });

          if (!foundUpdatedPreviousStreamId) {
            // Otherwise this must be a new stream
            added.push(currentId);
          }
        });
        removed = context.lastVideosToReceive.array().filter(function (idFromPrevious) {
          var stillReceiving = context.videosToReceive.contain(idFromPrevious);
          var isUpdated = simulcastStreamUpdates.has(idFromPrevious);
          return !stillReceiving && !isUpdated;
        });
      }

      this.logger.info("Request to update remote videos with added: ".concat(added, ", updated: ").concat(_toConsumableArray(simulcastStreamUpdates.entries()), ", removed: ").concat(removed));
      var updatedVideoSubscriptionConfigurations = [];

      var _iterator2 = _createForOfIteratorHelper(simulcastStreamUpdates.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ref3 = _step2.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var previousId = _ref2[0];
          var currentId = _ref2[1];
          var updatedConfig = new SignalingClientVideoSubscriptionConfiguration_1.default();
          updatedConfig.streamId = currentId;
          updatedConfig.attendeeId = context.videoStreamIndex.attendeeIdForStreamId(currentId);
          updatedConfig.mid = context.transceiverController.getMidForStreamId(previousId);

          if (updatedConfig.mid === undefined) {
            this.logger.info("No MID found for stream ID ".concat(previousId, ", cannot update stream without renegotiation"));
            return false;
          }

          updatedVideoSubscriptionConfigurations.push(updatedConfig); // We need to override some other components dependent on the subscribe paths for certain functionality

          context.transceiverController.setStreamIdForMid(updatedConfig.mid, currentId);
          context.videoStreamIndex.overrideStreamIdMappings(previousId, currentId);

          if (context.videoTileController.haveVideoTileForAttendeeId(updatedConfig.attendeeId)) {
            var tile = context.videoTileController.getVideoTileForAttendeeId(updatedConfig.attendeeId);

            if (!tile.setStreamId) {
              // Required function
              return false;
            }

            tile.setStreamId(currentId);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (updatedVideoSubscriptionConfigurations.length !== 0) {
        context.signalingClient.remoteVideoUpdate(updatedVideoSubscriptionConfigurations, []);
      } // Only simulcast stream switches (i.e. not add/remove/source switches) are possible currently


      if (added.length !== 0 || removed.length !== 0) {
        return false;
      }

      return true;
    }
  }, {
    key: "updateLocalVideoFromPolicy",
    value: function updateLocalVideoFromPolicy() {
      if (this.mayNeedRenegotiationForSimulcastLayerChange && !this.negotiatedBitrateLayersAllocationRtpHeaderExtension()) {
        this.logger.info('Needs regenotiation for local video simulcast layer change');
        this.mayNeedRenegotiationForSimulcastLayerChange = false;
        return false;
      } // Update bandwidth without renegotiation


      this.logger.info('Updating local video from policy without renegotiation');

      if (this.meetingSessionContext.enableSimulcast) {
        // `AttachMediaInputTask` will update sender's simulcast streams encoding parameters of the local video transceiver
        new AttachMediaInputTask_1.default(this.meetingSessionContext).run();
      } else {
        // `ReceiveVideoInputTask` will update `meetingSessionContext.videoCaptureAndEncodeParameter`
        // from uplink policy on internal state
        new ReceiveVideoInputTask_1.default(this.meetingSessionContext).run();
      }

      return true;
    }
  }, {
    key: "negotiatedBitrateLayersAllocationRtpHeaderExtension",
    value: function negotiatedBitrateLayersAllocationRtpHeaderExtension() {
      if (!this.meetingSessionContext.transceiverController.localVideoTransceiver()) {
        return false;
      }

      var parameters = this.meetingSessionContext.transceiverController.localVideoTransceiver().sender.getParameters();

      if (!parameters || !parameters.headerExtensions) {
        return false;
      }

      return parameters.headerExtensions.some(function (extension) {
        return extension.uri === 'http://www.webrtc.org/experiments/rtp-hdrext/video-layers-allocation00';
      });
    }
  }, {
    key: "restartLocalVideo",
    value: function restartLocalVideo(callback) {
      var _this10 = this;

      var restartVideo = function restartVideo() {
        return __awaiter(_this10, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee6() {
          return _regenerator.default.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!this._videoTileController.hasStartedLocalVideoTile()) {
                    _context6.next = 8;
                    break;
                  }

                  this.logger.info('stopping local video tile prior to local video restart');

                  this._videoTileController.stopLocalVideoTile();

                  this.logger.info('preparing local video restart update');
                  _context6.next = 6;
                  return this.actionUpdateWithRenegotiation(false);

                case 6:
                  this.logger.info('starting local video tile for local video restart');

                  this._videoTileController.startLocalVideoTile();

                case 8:
                  this.logger.info('finalizing local video restart update');
                  _context6.next = 11;
                  return this.actionUpdateWithRenegotiation(true);

                case 11:
                  callback();

                case 12:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
      };

      var result = this.sessionStateController.perform(SessionStateControllerAction_1.default.Update, function () {
        restartVideo();
      });
      return result === SessionStateControllerTransitionResult_1.default.Transitioned || result === SessionStateControllerTransitionResult_1.default.DeferredTransition;
    }
  }, {
    key: "replaceLocalVideo",
    value: function replaceLocalVideo() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var videoStream, videoTrack, localTile, state, settings;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                videoStream = null;
                _context7.prev = 1;
                _context7.next = 4;
                return this.mediaStreamBroker.acquireVideoInputStream();

              case 4:
                videoStream = _context7.sent;
                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](1);
                throw new Error("could not acquire video stream from mediaStreamBroker due to ".concat(_context7.t0.message));

              case 10:
                if (!(!videoStream || videoStream.getVideoTracks().length < 1)) {
                  _context7.next = 12;
                  break;
                }

                throw new Error('could not acquire video track');

              case 12:
                videoTrack = videoStream.getVideoTracks()[0];

                if (!(!this.meetingSessionContext || !this.meetingSessionContext.peer)) {
                  _context7.next = 15;
                  break;
                }

                throw new Error('no active meeting and peer connection');

              case 15:
                if (!this.meetingSessionContext.browserBehavior.requiresUnifiedPlan()) {
                  _context7.next = 20;
                  break;
                }

                _context7.next = 18;
                return this.meetingSessionContext.transceiverController.setVideoInput(videoTrack);

              case 18:
                _context7.next = 21;
                break;

              case 20:
                throw new Error('cannot replace track on Plan B');

              case 21:
                // if there is a local tile, a video tile update event should be fired.
                localTile = this.meetingSessionContext.videoTileController.getLocalVideoTile();

                if (localTile) {
                  state = localTile.state();
                  settings = videoStream.getVideoTracks()[0].getSettings(); // so tile update wil be fired.

                  localTile.bindVideoStream(state.boundAttendeeId, true, videoStream, settings.width, settings.height, state.streamId, state.boundExternalUserId);
                } // Update the active video input on subscription context to match what we just changed
                // so that subsequent meeting actions can reuse and destroy it.


                this.meetingSessionContext.activeVideoInput = videoStream;

              case 24:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 7]]);
      }));
    }
  }, {
    key: "restartLocalAudio",
    value: function restartLocalAudio(callback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee8() {
        var audioStream, audioTrack, replaceTrackSuccess;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                audioStream = null;
                _context8.prev = 1;
                _context8.next = 4;
                return this.mediaStreamBroker.acquireAudioInputStream();

              case 4:
                audioStream = _context8.sent;
                _context8.next = 10;
                break;

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8["catch"](1);
                this.logger.info('could not acquire audio stream from mediaStreamBroker');

              case 10:
                if (!(!audioStream || audioStream.getAudioTracks().length < 1)) {
                  _context8.next = 12;
                  break;
                }

                throw new Error('could not acquire audio track');

              case 12:
                this.connectionHealthData.reset();
                this.connectionHealthData.setConnectionStartTime();
                audioTrack = audioStream.getAudioTracks()[0];

                if (!(!this.meetingSessionContext || !this.meetingSessionContext.peer)) {
                  _context8.next = 17;
                  break;
                }

                throw new Error('no active meeting and peer connection');

              case 17:
                replaceTrackSuccess = false;

                if (!this.meetingSessionContext.browserBehavior.requiresUnifiedPlan()) {
                  _context8.next = 24;
                  break;
                }

                _context8.next = 21;
                return this.meetingSessionContext.transceiverController.replaceAudioTrack(audioTrack);

              case 21:
                replaceTrackSuccess = _context8.sent;
                _context8.next = 27;
                break;

              case 24:
                _context8.next = 26;
                return DefaultTransceiverController_1.default.replaceAudioTrackForSender(this.meetingSessionContext.localAudioSender, audioTrack);

              case 26:
                replaceTrackSuccess = _context8.sent;

              case 27:
                this._realtimeController.realtimeSetLocalAudioInput(audioStream);

                this.meetingSessionContext.activeAudioInput = audioStream;
                callback();

                if (!replaceTrackSuccess) {
                  _context8.next = 34;
                  break;
                }

                return _context8.abrupt("return", Promise.resolve());

              case 34:
                return _context8.abrupt("return", Promise.reject());

              case 35:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[1, 7]]);
      }));
    }
  }, {
    key: "actionUpdateWithRenegotiation",
    value: function actionUpdateWithRenegotiation(notify) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee9() {
        var _this11 = this;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // `actionUpdateWithRenegotiation` contains a significant portion of asynchronous tasks, so we need
                // to explicitly defer any task operation which may be performed on the event queue that may modify
                // mutable state needed to be consistent over the course of the update. The operations above do not
                // need this protection because they are synchronous.
                this.monitorTask.pauseResubscribeCheck();
                this.receiveIndexTask.pauseIngestion(); // TODO: do not block other updates while waiting for video input

                _context9.prev = 2;
                _context9.next = 5;
                return new SerialGroupTask_1.default(this.logger, this.wrapTaskName('AudioVideoUpdate'), [new ReceiveVideoInputTask_1.default(this.meetingSessionContext), new TimeoutTask_1.default(this.logger, new SerialGroupTask_1.default(this.logger, 'UpdateSession', [new AttachMediaInputTask_1.default(this.meetingSessionContext), new CreateSDPTask_1.default(this.meetingSessionContext), new SetLocalDescriptionTask_1.default(this.meetingSessionContext), new FinishGatheringICECandidatesTask_1.default(this.meetingSessionContext), new SubscribeAndReceiveSubscribeAckTask_1.default(this.meetingSessionContext), new SetRemoteDescriptionTask_1.default(this.meetingSessionContext)]), this.configuration.connectionTimeoutMs)]).run();

              case 5:
                if (notify) {
                  this.sessionStateController.perform(SessionStateControllerAction_1.default.FinishUpdating, function () {
                    _this11.actionFinishUpdating();
                  });
                }

                _context9.next = 11;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](2);
                this.sessionStateController.perform(SessionStateControllerAction_1.default.FinishUpdating, function () {
                  var status = new MeetingSessionStatus_1.default(_this11.getMeetingStatusCode(_context9.t0) || MeetingSessionStatusCode_1.default.TaskFailed);

                  if (status.statusCode() !== MeetingSessionStatusCode_1.default.IncompatibleSDP) {
                    _this11.logger.info('failed to update audio-video session');
                  }

                  _this11.handleMeetingSessionStatus(status, _context9.t0);
                });

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[2, 8]]);
      }));
    }
  }, {
    key: "notifyStop",
    value: function notifyStop(status, error) {
      var _a;

      this.forEachObserver(function (observer) {
        Types_1.Maybe.of(observer.audioVideoDidStop).map(function (f) {
          return f.bind(observer)(status);
        });
      });
      /* istanbul ignore else */

      if (this.eventController) {
        var _this$meetingSessionC = this.meetingSessionContext,
            signalingOpenDurationMs = _this$meetingSessionC.signalingOpenDurationMs,
            poorConnectionCount = _this$meetingSessionC.poorConnectionCount,
            startTimeMs = _this$meetingSessionC.startTimeMs,
            iceGatheringDurationMs = _this$meetingSessionC.iceGatheringDurationMs,
            attendeePresenceDurationMs = _this$meetingSessionC.attendeePresenceDurationMs,
            meetingStartDurationMs = _this$meetingSessionC.meetingStartDurationMs;
        var attributes = {
          maxVideoTileCount: this.meetingSessionContext.maxVideoTileCount,
          meetingDurationMs: startTimeMs === null ? 0 : Math.round(Date.now() - startTimeMs),
          meetingStatus: MeetingSessionStatusCode_1.default[status.statusCode()],
          signalingOpenDurationMs: signalingOpenDurationMs,
          iceGatheringDurationMs: iceGatheringDurationMs,
          attendeePresenceDurationMs: attendeePresenceDurationMs,
          poorConnectionCount: poorConnectionCount,
          meetingStartDurationMs: meetingStartDurationMs,
          retryCount: this.totalRetryCount
        };
        /* istanbul ignore next: toString is optional */

        var meetingErrorMessage = error && error.message || ((_a = status.toString) === null || _a === void 0 ? void 0 : _a.call(status)) || '';

        if (attributes.meetingDurationMs === 0) {
          attributes.meetingErrorMessage = meetingErrorMessage;
          delete attributes.meetingDurationMs;
          delete attributes.attendeePresenceDurationMs;
          delete attributes.meetingStartDurationMs;
          this.eventController.publishEvent('meetingStartFailed', attributes);
        } else if (status.isFailure() || status.isAudioConnectionFailure()) {
          attributes.meetingErrorMessage = meetingErrorMessage;
          this.eventController.publishEvent('meetingFailed', attributes);
        } else {
          this.eventController.publishEvent('meetingEnded', attributes);
        }
      }
    }
  }, {
    key: "actionFinishUpdating",
    value: function actionFinishUpdating() {
      // we do not update parameter for simulcast since they are updated in AttachMediaInputTask
      if (!this.meetingSessionContext.enableSimulcast) {
        if (this.useUpdateTransceiverControllerForUplink) {
          this.meetingSessionContext.videoUplinkBandwidthPolicy.updateTransceiverController();
        } else {
          var maxBitrateKbps = this.meetingSessionContext.videoCaptureAndEncodeParameter.encodeBitrates()[0];
          this.enforceBandwidthLimitationForSender(maxBitrateKbps);
        }
      }

      this.monitorTask.resumeResubscribeCheck();
      this.receiveIndexTask.resumeIngestion();
      this.logger.info('updated audio-video session');
    }
  }, {
    key: "reconnect",
    value: function reconnect(status, error) {
      var _this12 = this;

      var willRetry = this._reconnectController.retryWithBackoff(function () {
        return __awaiter(_this12, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee10() {
          var _this13 = this;

          return _regenerator.default.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  if (this.sessionStateController.state() === SessionStateControllerState_1.default.NotConnected) {
                    this.sessionStateController.perform(SessionStateControllerAction_1.default.Connect, function () {
                      _this13.actionConnect(true);
                    });
                  } else {
                    this.sessionStateController.perform(SessionStateControllerAction_1.default.Reconnect, function () {
                      _this13.actionReconnect(status);
                    });
                  }

                  this.totalRetryCount += 1;

                case 2:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this);
        }));
      }, function () {
        _this12.logger.info('canceled retry');
      });

      if (!willRetry) {
        this.sessionStateController.perform(SessionStateControllerAction_1.default.Fail, function () {
          _this12.actionDisconnect(status, false, error);
        });
      }

      return willRetry;
    }
  }, {
    key: "actionReconnect",
    value: function actionReconnect(status) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee11() {
        var _this14 = this;

        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!this._reconnectController.hasStartedConnectionAttempt()) {
                  this._reconnectController.startedConnectionAttempt(false);

                  this.forEachObserver(function (observer) {
                    Types_1.Maybe.of(observer.audioVideoDidStartConnecting).map(function (f) {
                      return f.bind(observer)(true);
                    });
                  });
                }

                this.meetingSessionContext.volumeIndicatorAdapter.onReconnect();
                this.connectionHealthData.reset();
                _context11.prev = 3;
                _context11.next = 6;
                return new SerialGroupTask_1.default(this.logger, this.wrapTaskName('AudioVideoReconnect'), [new TimeoutTask_1.default(this.logger, new SerialGroupTask_1.default(this.logger, 'Media', [new CleanRestartedSessionTask_1.default(this.meetingSessionContext), new SerialGroupTask_1.default(this.logger, 'Signaling', [new OpenSignalingConnectionTask_1.default(this.meetingSessionContext), new JoinAndReceiveIndexTask_1.default(this.meetingSessionContext), new ReceiveTURNCredentialsTask_1.default(this.meetingSessionContext)]), new CreatePeerConnectionTask_1.default(this.meetingSessionContext)]), this.configuration.connectionTimeoutMs), // TODO: Do we need ReceiveVideoInputTask in the reconnect operation?
                new ReceiveVideoInputTask_1.default(this.meetingSessionContext), new TimeoutTask_1.default(this.logger, new SerialGroupTask_1.default(this.logger, 'UpdateSession', [new AttachMediaInputTask_1.default(this.meetingSessionContext), new CreateSDPTask_1.default(this.meetingSessionContext), new SetLocalDescriptionTask_1.default(this.meetingSessionContext), new FinishGatheringICECandidatesTask_1.default(this.meetingSessionContext), new SubscribeAndReceiveSubscribeAckTask_1.default(this.meetingSessionContext), new SetRemoteDescriptionTask_1.default(this.meetingSessionContext)]), this.configuration.connectionTimeoutMs)]).run();

              case 6:
                this.sessionStateController.perform(SessionStateControllerAction_1.default.FinishConnecting, function () {
                  /* istanbul ignore else */
                  if (_this14.eventController) {
                    var _this14$meetingSessio = _this14.meetingSessionContext,
                        signalingOpenDurationMs = _this14$meetingSessio.signalingOpenDurationMs,
                        poorConnectionCount = _this14$meetingSessio.poorConnectionCount,
                        startTimeMs = _this14$meetingSessio.startTimeMs,
                        iceGatheringDurationMs = _this14$meetingSessio.iceGatheringDurationMs,
                        attendeePresenceDurationMs = _this14$meetingSessio.attendeePresenceDurationMs,
                        meetingStartDurationMs = _this14$meetingSessio.meetingStartDurationMs;
                    var attributes = {
                      maxVideoTileCount: _this14.meetingSessionContext.maxVideoTileCount,
                      meetingDurationMs: Math.round(Date.now() - startTimeMs),
                      meetingStatus: MeetingSessionStatusCode_1.default[status.statusCode()],
                      signalingOpenDurationMs: signalingOpenDurationMs,
                      iceGatheringDurationMs: iceGatheringDurationMs,
                      attendeePresenceDurationMs: attendeePresenceDurationMs,
                      poorConnectionCount: poorConnectionCount,
                      meetingStartDurationMs: meetingStartDurationMs,
                      retryCount: _this14.totalRetryCount
                    };

                    _this14.eventController.publishEvent('meetingReconnected', attributes);
                  }

                  _this14.actionFinishConnecting();
                });
                _context11.next = 12;
                break;

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11["catch"](3);
                // To perform the "Reconnect" action again, the session should be in the "Connected" state.
                this.sessionStateController.perform(SessionStateControllerAction_1.default.FinishConnecting, function () {
                  _this14.logger.info('failed to reconnect audio-video session');

                  var status = new MeetingSessionStatus_1.default(_this14.getMeetingStatusCode(_context11.t0) || MeetingSessionStatusCode_1.default.TaskFailed);

                  _this14.handleMeetingSessionStatus(status, _context11.t0);
                });

              case 12:
                this.connectionHealthData.setConnectionStartTime();

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[3, 9]]);
      }));
    }
  }, {
    key: "wrapTaskName",
    value: function wrapTaskName(taskName) {
      return "".concat(taskName, "/").concat(this.configuration.meetingId, "/").concat(this.configuration.credentials.attendeeId);
    }
  }, {
    key: "getMeetingStatusCode",
    value: function getMeetingStatusCode(error) {
      var matched = /the meeting status code: (\d+)/.exec(error && error.message);

      if (matched && matched.length > 1) {
        return Number.parseInt(matched[1], 10);
      }

      return null;
    }
  }, {
    key: "enforceBandwidthLimitationForSender",
    value: function enforceBandwidthLimitationForSender(maxBitrateKbps) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee12() {
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!this.meetingSessionContext.browserBehavior.requiresUnifiedPlan()) {
                  _context12.next = 5;
                  break;
                }

                _context12.next = 3;
                return this.meetingSessionContext.transceiverController.setVideoSendingBitrateKbps(maxBitrateKbps);

              case 3:
                _context12.next = 7;
                break;

              case 5:
                _context12.next = 7;
                return DefaultTransceiverController_1.default.setVideoSendingBitrateKbpsForSender(this.meetingSessionContext.localVideoSender, maxBitrateKbps, this.meetingSessionContext.logger);

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "handleMeetingSessionStatus",
    value: function handleMeetingSessionStatus(status, error) {
      var _this15 = this;

      this.logger.info("handling status: ".concat(MeetingSessionStatusCode_1.default[status.statusCode()]));

      if (!status.isTerminal()) {
        if (this.meetingSessionContext.statsCollector) {
          this.meetingSessionContext.statsCollector.logMeetingSessionStatus(status);
        }
      }

      if (status.statusCode() === MeetingSessionStatusCode_1.default.IncompatibleSDP) {
        this.restartLocalVideo(function () {
          _this15.logger.info('handled incompatible SDP by attempting to restart video');
        });
        return true;
      }

      if (status.statusCode() === MeetingSessionStatusCode_1.default.VideoCallSwitchToViewOnly) {
        this._videoTileController.removeLocalVideoTile();

        this.forEachObserver(function (observer) {
          Types_1.Maybe.of(observer.videoSendDidBecomeUnavailable).map(function (f) {
            return f.bind(observer)();
          });
        });
        return false;
      }

      if (status.isTerminal()) {
        this.logger.error('session will not be reconnected');

        if (this.meetingSessionContext.reconnectController) {
          this.meetingSessionContext.reconnectController.disableReconnect();
        }
      }

      if (status.isFailure() || status.isTerminal()) {
        if (this.meetingSessionContext.reconnectController) {
          var willRetry = this.reconnect(status, error);

          if (willRetry) {
            this.logger.warn("will retry due to status code ".concat(MeetingSessionStatusCode_1.default[status.statusCode()]).concat(error ? " and error: ".concat(error.message) : ""));
          } else {
            this.logger.error("failed with status code ".concat(MeetingSessionStatusCode_1.default[status.statusCode()]).concat(error ? " and error: ".concat(error.message) : ""));
          }

          return willRetry;
        }
      }

      return false;
    }
  }, {
    key: "setVideoMaxBandwidthKbps",
    value: function setVideoMaxBandwidthKbps(maxBandwidthKbps) {
      if (this.meetingSessionContext && this.meetingSessionContext.videoUplinkBandwidthPolicy) {
        this.logger.info("video send has ideal max bandwidth ".concat(maxBandwidthKbps, " kbps"));
        this.meetingSessionContext.videoUplinkBandwidthPolicy.setIdealMaxBandwidthKbps(maxBandwidthKbps);
      }
    }
  }, {
    key: "handleHasBandwidthPriority",
    value: function handleHasBandwidthPriority(hasBandwidthPriority) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee13() {
        var oldMaxBandwidth, newMaxBandwidth;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(this.meetingSessionContext && this.meetingSessionContext.videoUplinkBandwidthPolicy && !this.meetingSessionContext.enableSimulcast)) {
                  _context13.next = 13;
                  break;
                }

                if (!this.useUpdateTransceiverControllerForUplink) {
                  _context13.next = 6;
                  break;
                }

                this.meetingSessionContext.videoUplinkBandwidthPolicy.setHasBandwidthPriority(hasBandwidthPriority);
                _context13.next = 5;
                return this.meetingSessionContext.videoUplinkBandwidthPolicy.updateTransceiverController();

              case 5:
                return _context13.abrupt("return");

              case 6:
                oldMaxBandwidth = this.meetingSessionContext.videoUplinkBandwidthPolicy.maxBandwidthKbps();
                this.meetingSessionContext.videoUplinkBandwidthPolicy.setHasBandwidthPriority(hasBandwidthPriority);
                newMaxBandwidth = this.meetingSessionContext.videoUplinkBandwidthPolicy.maxBandwidthKbps();

                if (!(oldMaxBandwidth !== newMaxBandwidth)) {
                  _context13.next = 13;
                  break;
                }

                this.logger.info("video send bandwidth priority ".concat(hasBandwidthPriority, " max has changed from ").concat(oldMaxBandwidth, " kbps to ").concat(newMaxBandwidth, " kbps"));
                _context13.next = 13;
                return this.enforceBandwidthLimitationForSender(newMaxBandwidth);

              case 13:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "pauseReceivingStream",
    value: function pauseReceivingStream(streamId) {
      if (!!this.meetingSessionContext && this.meetingSessionContext.signalingClient) {
        this.meetingSessionContext.signalingClient.pause([streamId]);
      }
    }
  }, {
    key: "resumeReceivingStream",
    value: function resumeReceivingStream(streamId) {
      if (!!this.meetingSessionContext && this.meetingSessionContext.signalingClient) {
        this.meetingSessionContext.signalingClient.resume([streamId]);
      }
    }
  }, {
    key: "getRemoteVideoSources",
    value: function getRemoteVideoSources() {
      var videoStreamIndex = this.meetingSessionContext.videoStreamIndex;

      if (!videoStreamIndex) {
        this.logger.info('meeting has not started');
        return [];
      }

      var selfAttendeeId = this.configuration.credentials.attendeeId;
      return videoStreamIndex.allVideoSendingSourcesExcludingSelf(selfAttendeeId);
    }
  }, {
    key: "encodingSimulcastLayersDidChange",
    value: function encodingSimulcastLayersDidChange(simulcastLayers) {
      this.mayNeedRenegotiationForSimulcastLayerChange = true;
      this.forEachObserver(function (observer) {
        Types_1.Maybe.of(observer.encodingSimulcastLayersDidChange).map(function (f) {
          return f.bind(observer)(simulcastLayers);
        });
      });
    }
  }]);

  return DefaultAudioVideoController;
}();

exports.default = DefaultAudioVideoController;
DefaultAudioVideoController.MIN_VOLUME_DECIBELS = -42;
DefaultAudioVideoController.MAX_VOLUME_DECIBELS = -14;
DefaultAudioVideoController.PING_PONG_INTERVAL_MS = 10000;